import QRCode from 'qrcode';

/**
 * QR 코드를 생성하고 data URL을 반환하는 함수
 *
 * @param data QR 코드에 인코딩할 데이터
 * @param size QR 코드 크기 (기본: 200)
 * @returns data URL (base64 이미지)
 */
export const generateQRCode = async (data: string, size = 300): Promise<string> => {
  try {
    const dataUrl = await QRCode.toDataURL(data, {
      width: size,
      margin: 1,
    });
    return dataUrl;
  } catch (error) {
    console.error('QR 코드 생성 실패:', error);
    throw new Error('QR 코드 생성에 실패했습니다.');
  }
};
